<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import VueScript from 'vue-script';

export default {
  mixins: [fandomBasicMixin],
  components: {
    VueScript
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" v-if="isContentVisibleToUser()" :class="contentType" class="py-4" form-integration-component>
    <div v-if="content.description" v-html="content.description" class="my-4"></div>
    <vue-script :id="`#script-${contentId}`" :script="content.snippet"></vue-script>
  </div>
</template>